export default __webpack_public_path__ + "static/media/confirmed.8a27edd9.svg";